import { AwsConfig as AwsConstants } from '../Constants';
import BaseService, { RequestInterface } from '../Base';
import IPagination from '@interfaces/IPagination';
import BasePaginationQuery from '@interfaces/base-pagination-query';
import { IModel3D } from '@interfaces/IModel3D';

export default class Model3DService extends BaseService {
  constructor() {
    super(AwsConstants.API_CONFIG, '3d-model');
  }

  async paging(query: BasePaginationQuery, fields?: string[]): Promise<IPagination<IModel3D>> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields)
    };
    if (query.unit) {
      params.queryStringParameters['unit'] = query.unit;
    }
    if (query.limit) {
      params.queryStringParameters['limit'] = query.limit;
    }
    if (query.offset) {
      params.queryStringParameters['offset'] = query.offset;
    }
    if (query.from) {
      params.queryStringParameters['from'] = query.offset;
    }
    if (query.to) {
      params.queryStringParameters['to'] = query.offset;
    }
    if (query.search) {
      params.queryStringParameters['search'] = query.search; // by name
    }

    const res = await super.get<IPagination<IModel3D>>('', params);
    return res;
  }
  async getById(id: string, unit: string, fields?: string[]): Promise<IModel3D> {
    const params: RequestInterface = {
      queryStringParameters: super.setFields(fields),
    };
    params.queryStringParameters['unit'] = unit;
    const res = await super.get<IModel3D>(id, params);
    return res;
  }
  async create(data: IModel3D, unit: string): Promise<IModel3D> {
    const params: RequestInterface = {
      body: data,
      queryStringParameters: { unit: unit }
    };
    const res = await super.post<IModel3D>('', params);
    return res;
  }
  async updateById(id: string, unit: string, data: IModel3D): Promise<IModel3D> {
    const params: RequestInterface = {
      body: data,
      queryStringParameters: { unit: unit }
    };
    const res = await super.put<IModel3D>(id, params);
    return res;
  }

  async deleteById(id: string, unit: string): Promise<void> {
    const params: RequestInterface = {
      queryStringParameters: { unit: unit }
    }
    await super.delete<void>(id, params);
  }

  async unitAdd(id: string, unitId: string, actualUnit: string): Promise<IModel3D> {
    const params: RequestInterface = {
      queryStringParameters: { unit: actualUnit }
    };

    const res = await super.patch<IModel3D>(`${id}/unit/${unitId}`, params);
    return res;
  }

  async unitRemove(id: string, unitId: string, actualUnit: string): Promise<void> {
    const params: RequestInterface = {
      queryStringParameters: { unit: actualUnit }
    };
    await super.delete<void>(`${id}/unit/${unitId}`, params);
  }
}